import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
} from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import { zoomSdkApi } from './zoomSdkQueries'
import { appApi } from './appApiQueries'
import rootSlice from './root'
import { rtkQueryErrorMiddleware } from './rtkErrorLogger'
import dialogSlice from './dialog'
import fileSlice from './file'
import collabFileSlice from './collabFile'

const rootReducer = combineReducers({
  [appApi.reducerPath]: appApi.reducer,
  [zoomSdkApi.reducerPath]: zoomSdkApi.reducer,
  root: rootSlice.reducer,
  dialog: dialogSlice.reducer,
  file: fileSlice.reducer,
  collabFile: collabFileSlice.reducer,
})

export const store = configureStore({
  reducer: rootReducer,
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      zoomSdkApi.middleware,
      appApi.middleware,
      rtkQueryErrorMiddleware
    ),
})

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof rootReducer>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
